import { AbstractEntityMapper } from '@pf/shared-services';
import {
    ReceiptLineCreate,
    ReceiptLineDto,
    ReceiptLineRead,
    ReceiptLineSearchParams,
} from '../../entities/receipt-line.dto';
import { Injectable } from '@angular/core';
import { PlatformWmsMapper } from '../platform-wms.mapper';
import { ReceiptLineMetadataMap } from './receipt-line.mapping-profile';

@Injectable()
export class ReceiptLineMapper extends AbstractEntityMapper<
    ReceiptLineRead,
    ReceiptLineCreate,
    ReceiptLineDto,
    ReceiptLineSearchParams
> {
    constructor() {
        super(
            ReceiptLineDto,
            PlatformWmsMapper,
            ReceiptLineMetadataMap.symbols
        );
    }
}
